import { useClearDues } from '@/hooks/useClearDues'
import { usePlanExpiration } from '@/hooks/usePlanExpiration'
import { formatBillingDate } from '@/utils/billingDateUtils'
import { AlertTriangle } from 'lucide-react'
import { Banner } from './Banner'

export function BillingWarningBanner() {
	const expirationStatus = usePlanExpiration()
	const handleClearDues = useClearDues()

	if (!expirationStatus.isExpired || expirationStatus.isAccessBlocked) {
		return null
	}

	const isPendingInitialPayment = expirationStatus.isPendingInitialPayment
	const isCancelled = expirationStatus.isAccessBlocked
	const expirationDateStr = expirationStatus.expirationDate ? formatBillingDate(expirationStatus.expirationDate) : '--'
	const warningDescription = isPendingInitialPayment
		? 'Your subscription is inactive due to pending initial payment. Please clear the dues to activate your plan.'
		: isCancelled
			? `Your current plan is expired on ${expirationDateStr}, please ensure all dues are cleared to avoid service interruption.`
			: `Your current plan is about to be cancelled on ${expirationDateStr}, please ensure all dues are cleared to avoid service interruption.`

	return (
		<Banner
			description={warningDescription}
			icon={AlertTriangle}
			variant='warning'
			actions={[{ label: 'Clear Dues', onClick: handleClearDues }]}
		/>
	)
}
